import React from "react";
// import Coupon from "../../Pages/CouponManagement/CouponManagement";
import { Navigate, Route, Routes } from "react-router-dom";
import CouponManagement from "../../Pages/CouponManagement/CouponManagement.Page";
import AddPercentageDiscount from "../../Pages/AddCoupon/AddPercentageDiscount.Page";
import AddFixedDiscount from "../../Pages/AddCoupon/AddFixedDiscount.Page";
import AddBuyXGetX from "../../Pages/AddCoupon/AddBuyXGetX.Page";
import CouponDetails from "../../Pages/CouponDetails/CouponDetails.Page";
import { AddCouponFormContextProvider } from "../../Context/Coupons/AddCouponFormContext";
import EditPercentageDiscount from "../../Pages/EditCoupon/EditPercentageDiscount.Page";
import EditFixedDiscount from "../../Pages/EditCoupon/EditFixedDiscount.Page";
import EditBuyXGetX from "../../Pages/EditCoupon/EditBuyXGetX.Page";

export default function CouponRoute() {
    return (
        <Routes>
            {/* <Route index element={<Coupon />} /> */}

            <Route index element={<CouponManagement />} />

            <Route path='coupon'>
                <Route index element={<Navigate to="/coupon-management" replace />} />

                <Route path=':couponId' element={<CouponDetails />} />
            </Route>

            <Route path='add-coupon'>
                <Route index element={<Navigate to="/coupon-management" replace />} />

                <Route path='percentage-discounts' 
                    element={
                        <AddCouponFormContextProvider>
                            <AddPercentageDiscount />
                        </AddCouponFormContextProvider>
                    } 
                />

                <Route path='fixed-discounts' 
                    element={
                        <AddCouponFormContextProvider>
                            <AddFixedDiscount />
                        </AddCouponFormContextProvider>
                    } 
                />

                <Route path='buy-x-get-x' 
                    element={
                        <AddCouponFormContextProvider>
                            <AddBuyXGetX />
                        </AddCouponFormContextProvider>
                    } 
                />
            </Route>

            <Route path='edit-coupon'>
                <Route index element={<Navigate to="/coupon-management" replace />} />

                <Route path='percentage-discounts'>
                    <Route index element={<Navigate to="/coupon-management" replace />} />

                    <Route path=':couponId' 
                        element={
                            <AddCouponFormContextProvider>
                                <EditPercentageDiscount />
                            </AddCouponFormContextProvider>
                        } 
                    />
                </Route>

                <Route path='fixed-discounts'>
                    <Route index element={<Navigate to="/coupon-management" replace />} />

                    <Route path=':couponId' 
                        element={
                            <AddCouponFormContextProvider>
                                <EditFixedDiscount />
                            </AddCouponFormContextProvider>
                        } 
                    />
                </Route>

                <Route path='buy-x-get-x'>
                    <Route index element={<Navigate to="/coupon-management" replace />} />

                    <Route path=':couponId' 
                        element={
                            <AddCouponFormContextProvider>
                                <EditBuyXGetX />
                            </AddCouponFormContextProvider>
                        } 
                    />
                </Route>
            </Route>

            <Route path='*' element={<Navigate to="/coupon-management" replace />} />
        </Routes>
    );
}
